import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button, Card, CardBody } from "reactstrap";

const DeviceNotRegistered = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    macId: null,
    ipAddress: null,
  });

  useEffect(() => {
    document.title = "Device Not Registered | Ordering System";

    // Try to get any available device info
    const macId = localStorage.getItem("macId");
    const ipAddress = localStorage.getItem("ipAddress");

    setDeviceInfo({
      macId: macId || "Not Available",
      ipAddress: ipAddress || "Not Available",
    });
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleClearData = () => {
    if (
      window.confirm(
        "Are you sure you want to clear all device data? This will reset all local settings."
      )
    ) {
      localStorage.clear();
      window.location.reload();
    }
  };

  return (
    <React.Fragment>
      <div className="auth-page-wrapper bg-light py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content overflow-hidden p-0">
          <Container fluid={true}>
            <Row className="justify-content-center">
              <Col xl={6} lg={7} md={9} className="text-center">
                {/* Header Section */}
                <div className="mb-5">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#f8f9fa",
                      border: "3px solid #dee2e6",
                    }}
                  >
                    <i
                      className="ri-tablet-line"
                      style={{ fontSize: "40px", color: "#6c757d" }}
                    ></i>
                  </div>
                  <h2 className="text-dark mb-2 fw-semibold">
                    Device Not Registered
                  </h2>
                  <p className="text-muted">
                    This kiosk requires configuration to continue
                  </p>
                </div>

                <Card className="border shadow-sm">
                  <CardBody className="p-4">
                    {/* Device Information Section */}
                    <div className="mb-4">
                      <h5 className="text-dark mb-3 text-start">
                        Device Information
                      </h5>
                      <div className="bg-light p-3 rounded">
                        <table className="table table-sm table-borderless mb-0">
                          <tbody>
                            <tr>
                              <td className="text-muted text-start" style={{ width: "40%" }}>
                                <i className="ri-fingerprint-line me-2"></i>
                                MAC Address
                              </td>
                              <td className="text-dark text-end font-monospace fw-medium">
                                {deviceInfo.macId}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted text-start">
                                <i className="ri-global-line me-2"></i>
                                IP Address
                              </td>
                              <td className="text-dark text-end font-monospace fw-medium">
                                {deviceInfo.ipAddress}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <hr className="my-4" />

                    {/* Instructions Section */}
                    <div className="mb-4 text-start">
                      <h5 className="text-dark mb-3">Required Actions</h5>
                      <ol className="text-muted mb-0 ps-3">
                        <li className="mb-2">
                          Contact your system administrator to register this
                          device
                        </li>
                        <li className="mb-2">
                          Provide the MAC Address displayed above for device
                          registration
                        </li>
                        <li className="mb-2">
                          Once registered, use the refresh button below to
                          reload the application
                        </li>
                      </ol>
                    </div>

                    <hr className="my-4" />

                    {/* Action Buttons */}
                    <div className="d-flex gap-3 justify-content-center flex-wrap">
                      <Button
                        color="primary"
                        size="lg"
                        onClick={handleRefresh}
                        className="px-4"
                      >
                        <i className="ri-refresh-line me-2"></i>
                        Refresh Page
                      </Button>
                      <Button
                        color="secondary"
                        size="lg"
                        outline
                        onClick={handleClearData}
                        className="px-4"
                      >
                        <i className="ri-delete-bin-line me-2"></i>
                        Clear Device Data
                      </Button>
                    </div>
                  </CardBody>
                </Card>

                {/* Footer */}
                <div className="mt-4">
                  <p className="text-muted small mb-0">
                    <i className="ri-customer-service-line me-1"></i>
                    For assistance, please contact your system administrator or
                    support team
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeviceNotRegistered;